import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { DUPE_QA } from "../../Table/TableQueryColumn";

const initialState = {
    data: {
        MSIID: '',
        MemberID: '',
        Carrier: '',
        PlanType: '',
        Account: '',
        Group: '',
        StartDate: '',
        EndDate: '',
        ChangeDate: '',
        PlanYear: '',
        totalCount: 0,
        page: 0,
        pageSize: 50,
        sortOrder: "asc",
        columnName: "MSI ID",
        collectionName: "Plan Year All"
    },
    dataAll: "",
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: false,
    clear: false,
    showAll: false,
    inputError: {
        MSIID: false,
        Account: false,
        Group: false,
        MemberID: false,
        Carrier: false,
    }
}

export const getDupeQAData = createAsyncThunk('data/getDupeQAData',
    async (data, { rejectWithValue }) => {
        try {
            let queryByDupeQA =
                `query GetMemberDupeQADetails{
                    GetMemberDupeQADetails(
                pageNumber:${data.page + 1},
                pageSize:${data.pageSize},
                sortOrder:"${data.sortOrder}",
                columnName:"${data.columnName}",
                collectionName:"Dupe QA"
                ${data.Group ? `,group: "${data.Group}"` : ""}
                ${data.MSIID ? `,msiID: "${data.MSIID}"` : ""}
                ${data.Carrier ? `,carrier: "${data.Carrier}"` : ""}
                ${data.MemberID ? `,member: "${data.MemberID}"` : ""}
                ${data.Account ? `,account: "${data.Account}"` : ""}
                `;

            queryByDupeQA += DUPE_QA

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryByDupeQA, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

export const getDupeQADataDownloadAll = createAsyncThunk('data/getDupeQADataDownloadAll',
    async (data, { rejectWithValue }) => {
        try {
            let queryByDupeQA =
                `query GetAllMemberDupeQADetails{
                    GetAllMemberDupeQADetails(
                collectionName:"Dupe QA"
                ${data.Group ? `,group: "${data.Group}"` : ""}
                ${data.MSIID ? `,msiID: "${data.MSIID}"` : ""}
                ${data.Carrier ? `,carrier: "${data.Carrier}"` : ""}
                ${data.MemberID ? `,member: "${data.MemberID}"` : ""}
                ${data.Account ? `,account: "${data.Account}"` : ""}
                `;

            queryByDupeQA += DUPE_QA

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryByDupeQA, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const DupeQASlice = createSlice({
    name: 'dupeQA',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        },
        showAll: (state, action) => {
            state.showAll = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDupeQAData.pending, (state) => {
                //state.loading = true;
                state.error = false;
            })
            .addCase(getDupeQAData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetMemberDupeQADetails.totalCount;
                state.data.tableData = response.data.data.GetMemberDupeQADetails.data;
            })
            .addCase(getDupeQAData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(getDupeQADataDownloadAll.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getDupeQADataDownloadAll.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                //state.data.totalCount = response.data.data.GetMemberPlanYearAllDetails.totalCount;
                state.data.tableData = response.data.data.GetAllMemberDupeQADetails.data;
            })
            .addCase(getDupeQADataDownloadAll.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }
})

export const { currentData, clearData, updateSearch, searchClicked, clearTable,
    searchTriggered, updateInputError, resetError, resetToaster, showAll } = DupeQASlice.actions;
export default DupeQASlice.reducer
